import * as React from 'react';
import logo from '../../assets/images/ac_logo-reversed.svg';
// import NDClogo from "../../assets/images/Rectangle 151.svg";
import {
  AppBar,
  Box,
  ClickAwayListener,
  Toolbar,
  useMediaQuery,
  useTheme
} from '@mui/material';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import CheckIcon from '@mui/icons-material/Check';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuIcon from '@mui/icons-material/Menu';
import ndcLogo from '../../assets/images/NewDistributionCapability.svg';
import AppMenuBar from '../AppMenuBar/AppMenuBar';
import { useAdobeAnalytics } from '../../providers/AdobeAnalytics';
import './AppHeader.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import AppSignedUser from './AppSignedUser/AppSignedUser';
import AnnouncementBanner from '../AnnouncementBanner/AnnouncementBanner';
import { useTranslation } from 'react-i18next';
import AppLoader from '../AppLoader/AppLoader';
import { useSelector } from 'react-redux';

export default function AppHeader({
  // data,
  userName,
  coName,
  logout,
  selectedLanguage,
  setSelectedLanguage,
  setHeaderHeight,
  setLogoHeight,
  setAnnouncementBanner
}) {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenu, setOpenMenu] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [arrowRef, setArrowRef] = React.useState<HTMLSpanElement | null>(null);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const menuBarRef = React.useRef<HTMLDivElement>(null);
  const [warningHeight, setWarningHeight] = React.useState(0);
  const [menuBarHeight, setMenuBarHeight] = React.useState(0);
  const [isMenu, setIsMenu] = React.useState(0);
  const open = Boolean(anchorEl);

  const apiLoading = useSelector((state: any) => state.apiLoader.isLoading);

  React.useEffect(() => {
    const handleResize = () => {
      if (headerRef.current) {
        const totalHeaderHeight =
          (menuBarRef.current ? menuBarRef.current?.offsetHeight : 0) +
          (warningHeight ? warningHeight : 0);
        // +
        // (headerRef.current ? headerRef.current?.offsetHeight : 0);
        setHeaderHeight(totalHeaderHeight);

        setLogoHeight(
          (menuBarRef.current ? menuBarRef.current?.offsetHeight : 0) +
            (warningHeight ? warningHeight : 0) +
            (headerRef.current ? headerRef.current?.offsetHeight : 0)
        );
      }

      setMenuBarHeight(
        menuBarRef.current ? menuBarRef.current?.offsetHeight : 0
      );
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };

    // eslint-disable-next-line
  }, [warningHeight, headerRef.current, menuBarRef.current, isMenu]);

  const isSubseller = !location.pathname.toLowerCase().includes('subseller');
  const isBackOffice = !location.pathname.toLowerCase().includes('backoffice');
  const isMicrosite = !location.pathname.toLowerCase().includes('events');

  const { adobeAnalyticsSectionClick, adobeSiteInteraction } =
    useAdobeAnalytics();

  const menuLangRef = React.useRef(null) as any;
  const selectLangRef = React.useRef() as any;
  const focusOptionOnOpenRef = React.useRef(false);

  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  const bannerText = useMediaQuery('(max-width: 900px)');

  React.useEffect(() => {
    if (!isSubseller && !isBackOffice && !isMicrosite) {
      setHeaderHeight(0);
    }
    // eslint-disable-next-line
  }, [isSubseller, isBackOffice, isMicrosite]);

  React.useEffect(() => {
    if (open && focusOptionOnOpenRef.current) {
      focusOptionOnOpenRef.current = false;
      selectLangRef.current?.focus();
    }
  }, [open]);

  const handleOptionChange = (lang) => {
    const otherLangCode = lang.substring(0, 2).toLowerCase();
    const path = window.location.search
      ? window.location.pathname + window.location.search
      : window.location.pathname;
    const updatedPathname = path.replace(
      `/${i18n.language}/`,
      `/${otherLangCode}/`
    );

    window.location.href = updatedPathname;
  };

  const handleMenuClick = () => {
    setOpenMenu(!openMenu);
  };

  const id = open ? 'simple-popper' : undefined;

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/${i18n.language}/ndc-program/home`);
    adobeAnalyticsSectionClick('home button');
    adobeSiteInteraction('home button');
  };

  const handleLogoKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      handleLogoClick();
    }
  };

  const data = t('navigation', { returnObjects: true });

  return (
    <>
      <AppBar
        className="header"
        position="fixed"
        sx={{ padding: '0 !important' }}
        ref={headerRef}
      >
        {' '}
        {apiLoading ? <AppLoader /> : null}
        <Toolbar sx={{ padding: '0 !important' }}>
          <Box className="header__content" sx={{ padding: 0, width: '100%' }}>
            <div className="logo homeLink">
              {!md && (
                <MenuIcon
                  fontSize="medium"
                  sx={{ marginRight: '10px', cursor: 'pointer' }}
                  onClick={handleMenuClick}
                />
              )}
              <div
                className="logo__link"
                role="link"
                tabIndex={0}
                aria-label={t('appHeader.returnToHome')}
                onClick={handleLogoClick}
                onKeyDown={handleLogoKeyDown}
              >
                <div className="logo__airCanada">
                  <img
                    alt=""
                    src={logo}
                    aria-hidden="true"
                    className={`${sm ? 'mobileAClogo' : ''}`}
                  />
                </div>
                <div className={`logo__NDC ${sm ? 'mobileNDClogo' : ''}`}>
                  {/* {md ? logoTextDT : "NDC"} */}
                  {bannerText ? (
                    <span aria-hidden="true">NDC</span>
                  ) : i18n.language !== 'fr' ? (
                    <img alt="" src={ndcLogo} aria-hidden="true" />
                  ) : (
                    <div className="frLogo" aria-hidden="true">
                      NOUVELLE CAPACITÉ DE DISTRIBUTION
                    </div>
                  )}
                </div>
              </div>
            </div>
            {md && (
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <div className="search_and_lang-Wrapper">
                  <div className="language">
                    <Button
                      variant="text"
                      size="xl"
                      ref={menuLangRef}
                      aria-expanded={open}
                      aria-haspopup="true"
                      {...(open && { 'aria-controls': 'lang-menu-list' })}
                      id="lang-menu-button"
                      aria-label={
                        t('appHeader.selectLanguage') +
                        t('appHeader.readableLanguage')
                      }
                       sx={{
                        '&:focus-visible': {
                          outline: '2px solid white',
                          outlineOffset: '10px',
                        },
                      }}
                      disableRipple
                      onClick={(event) => {
                        setAnchorEl(anchorEl ? null : event.currentTarget);
                      }}
                      onKeyDown={(event) => {
                        if (event.key === 'Tab' && open) {
                          event.preventDefault();
                          selectLangRef.current.focus();
                        }
                        if (event.key === 'Tab' && event.shiftKey && open) {
                          setAnchorEl(null);
                        }
                        if (event.key === 'ArrowUp') {
                          event.preventDefault();
                          if (open) {
                            selectLangRef.current?.focus();
                          } else {
                            focusOptionOnOpenRef.current = true;
                            setAnchorEl(event.currentTarget);
                          }
                        }
                        if (event.key === 'ArrowDown') {
                          event.preventDefault();
                          if (open) {
                            selectLangRef.current?.focus();
                          } else {
                            focusOptionOnOpenRef.current = true;
                            setAnchorEl(event.currentTarget);
                          }
                        }
                        if (event.key === 'Escape' && open) {
                          event.preventDefault();
                          setAnchorEl(null);
                          menuLangRef.current?.focus();
                        }
                      }}
                    >
                      {t('appHeader.readableLanguage')}{' '}
                      <KeyboardArrowDownIcon />
                    </Button>
                    <Popper
                      id={id}
                      role="presentation"
                      open={open}
                      anchorEl={anchorEl}
                      placement="bottom"
                      disablePortal={true}
                      className="language-popper"
                      modifiers={[
                        {
                          name: 'arrow',
                          enabled: true,
                          options: {
                            padding: 5,
                            element: arrowRef
                          }
                        }
                      ]}
                      style={{
                        zIndex: 999,
                        marginRight: '20px'
                      }}
                    >
                      <ClickAwayListener onClickAway={handleClickAway}>
                        <Paper role="presentation" className="language-popper-content">
                          <List id="lang-menu-list" role="menu">
                            <ListItem disablePadding aria-hidden="true">
                              <ListItemText
                                primary={t('appHeader.readableLanguage')}
                                style={{
                                  color: '#005078',
                                  paddingLeft: '15px'
                                }}
                              />
                              <ListItemIcon>
                                <CheckIcon />
                              </ListItemIcon>
                            </ListItem>
                            <Divider
                              variant="middle"
                              style={{ padding: '5px' }}
                              aria-hidden="true"
                            />
                            <ListItem disablePadding role="none">
                              <ListItemButton
                                role="menuitem"
                                ref={selectLangRef}
                                sx={{
                                  '&:focus-visible': {
                                    backgroundClip: 'padding-box',
                                    borderRadius: '10px',
                                    outline: '4px solid black'
                                  }
                                }}
                                disableRipple
                                onClick={() =>
                                  handleOptionChange(
                                    t('appHeader.otherReadableLanguage')
                                  )
                                }
                                onKeyDown={(event) => {
                                  if (event.key === 'Tab' && !event.shiftKey) {
                                    setAnchorEl(null);
                                  }
                                  if (
                                    event.key === 'ArrowUp' ||
                                    event.key === 'ArrowDown'
                                  ) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    selectLangRef.current?.focus();
                                  }
                                  if (event.key === 'Escape') {
                                    event.preventDefault();
                                    setAnchorEl(null);
                                    menuLangRef.current?.focus();
                                  }
                                }}
                              >
                                <ListItemText
                                  primary={t('appHeader.otherReadableLanguage')}
                                  style={{ color: '#4A4F55' }}
                                />
                              </ListItemButton>
                            </ListItem>
                          </List>
                          <div
                            className="language-popper-arrow"
                            ref={setArrowRef}
                          />
                        </Paper>
                      </ClickAwayListener>
                    </Popper>
                  </div>
                </div>
                {isSubseller && isBackOffice && isMicrosite && (
                  <AppSignedUser
                    userName={userName}
                    coName={coName}
                    logout={logout}
                  />
                )}
              </Box>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar /> {/* Second toolbar needed for matui bug on fixed AppBar */}
      {(md || openMenu) && ( //main nav
        <nav
          id="menuBarWrapper"
          aria-label="primary"
          ref={menuBarRef}
        >
          <AppMenuBar
            data={isSubseller && isBackOffice && isMicrosite ? data : null}
            setOpenMenu={setOpenMenu}
            userName={userName}
            coName={coName}
            logout={logout}
            setIsMenu={setIsMenu}
          />
        </nav>
      )}
      {isSubseller && isBackOffice && isMicrosite && (
        <div style={{ marginTop: `${menuBarHeight}px` }}>
          <AnnouncementBanner
            setWarningHeight={setWarningHeight}
            content={t('announcement_banner_banner', { returnObjects: true })}
            setAnnouncementBanner={setAnnouncementBanner}
          ></AnnouncementBanner>
        </div>
      )}
    </>
  );
}

